/* ═══════════════════════════════════════════════════════════════
   Header interactions — shop mega-menu and mobile drawer.

   Vanilla, no framework: the React version held `shopOpen` /
   `open` / `mobileShopOpen` in state, and each of those is just an
   [hidden] attribute plus an aria-expanded here.

   Pointer devices open the mega-menu on hover with the same 120ms
   close grace the React version used, so a diagonal mouse path from
   the trigger to a tile does not dismiss it. Touch and keyboard get
   click/Enter instead, since hover never fires for them.
   ═══════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var CLOSE_GRACE_MS = 120;

  function canHover() {
    return window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  }

  function setExpanded(trigger, panel, open) {
    trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) {
      panel.removeAttribute('hidden');
    } else {
      panel.setAttribute('hidden', '');
    }
  }

  function shopMenu(root) {
    var wrap = root.querySelector('[data-gmd-shop]');
    if (!wrap) return;

    var trigger = wrap.querySelector('[data-gmd-shop-trigger]');
    var panel = wrap.querySelector('[data-gmd-shop-menu]');
    if (!trigger || !panel) return;

    var closeTimer = null;

    function open() {
      clearTimeout(closeTimer);
      setExpanded(trigger, panel, true);
    }

    function closeSoon() {
      clearTimeout(closeTimer);
      closeTimer = setTimeout(function () {
        setExpanded(trigger, panel, false);
      }, CLOSE_GRACE_MS);
    }

    function closeNow() {
      clearTimeout(closeTimer);
      setExpanded(trigger, panel, false);
    }

    wrap.addEventListener('mouseenter', function () {
      if (canHover()) open();
    });
    wrap.addEventListener('mouseleave', function () {
      if (canHover()) closeSoon();
    });

    // Without hover the trigger is a toggle, not a link, on first tap.
    trigger.addEventListener('click', function (e) {
      if (canHover()) return;
      if (trigger.getAttribute('aria-expanded') !== 'true') {
        e.preventDefault();
        open();
      }
    });

    // Keyboard: the panel is reachable by Tab because it is a sibling in
    // source order, so opening on focus is all that is needed.
    trigger.addEventListener('focus', open);
    wrap.addEventListener('focusout', function (e) {
      if (!wrap.contains(e.relatedTarget)) closeNow();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && trigger.getAttribute('aria-expanded') === 'true') {
        closeNow();
        trigger.focus();
      }
    });

    document.addEventListener('click', function (e) {
      if (!wrap.contains(e.target)) closeNow();
    });
  }

  function drawer(root) {
    var toggle = root.querySelector('[data-gmd-drawer-toggle]');
    var panel = root.querySelector('[data-gmd-drawer]');
    if (!toggle || !panel) return;

    var burgerOpen = toggle.querySelector('[data-gmd-burger-open]');
    var burgerClose = toggle.querySelector('[data-gmd-burger-close]');

    function paintBurger(open) {
      if (burgerOpen) burgerOpen.hidden = open;
      if (burgerClose) burgerClose.hidden = !open;
    }

    toggle.addEventListener('click', function () {
      var open = toggle.getAttribute('aria-expanded') !== 'true';
      setExpanded(toggle, panel, open);
      paintBurger(open);
    });

    // Nested "Shop" accordion inside the drawer.
    var shopToggle = panel.querySelector('[data-gmd-drawer-shop]');
    var shopPanel = shopToggle && document.getElementById(shopToggle.getAttribute('aria-controls'));
    if (shopToggle && shopPanel) {
      shopToggle.addEventListener('click', function () {
        setExpanded(shopToggle, shopPanel, shopToggle.getAttribute('aria-expanded') !== 'true');
      });
    }

    // Any navigation closes the drawer — on a real page load it would close
    // itself, but same-page anchors and the theme editor would leave it open.
    panel.addEventListener('click', function (e) {
      if (e.target.closest('a')) {
        setExpanded(toggle, panel, false);
        paintBurger(false);
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && toggle.getAttribute('aria-expanded') === 'true') {
        setExpanded(toggle, panel, false);
        paintBurger(false);
        toggle.focus();
      }
    });
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-gmd-header]').forEach(function (root) {
      if (root.dataset.gmdReady) return;
      root.dataset.gmdReady = '1';
      shopMenu(root);
      drawer(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  // The theme editor replaces the section's DOM on every settings change.
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();
